// extracted by mini-css-extract-plugin
export default {"sirTablePd":"1.35rem","tableHeader":"TableHeader_tableHeader__x7WwX"};